import { api } from "./client.js";

export const accountApi = {
  checkHandle: (handle: string) =>
    api.get<{ available: boolean; reason?: string }>(
      `/api/account/handle-available?handle=${encodeURIComponent(handle)}`,
    ),
  setHandle: (handle: string) => api.patch<{ handle: string }>("/api/account/handle", { handle }),
};
